import React from "react";
import { ThemeProvider } from "styled-components";
import GlobalStyles from "./globalStyles";
import DefaultUptimeTheme from "./defaultTheme";

export interface IUptimeThemeProps {
  /**
   * Uptime theme object.
   *
   * @default Default Uptime theme object.
   */
  theme?: typeof DefaultUptimeTheme;

  children?: React.ReactNode;
}

export interface IThemeProps {
  theme: typeof DefaultUptimeTheme;
}
/**
 * Root provider for Uptime Design System.
 */
export const UptimeTheme: React.FC<IUptimeThemeProps> = ({
  theme = DefaultUptimeTheme,
  children,
}) => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      {children}
    </ThemeProvider>
  );
};

export default UptimeTheme;
